import { Receiver } from '@/constants/enum';

export const sendToOptions = [
  { label: 'Customer', value: Receiver.Customer },
  { label: 'Merchant', value: Receiver.Merchant },
];
